module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1147.2a82537b.png";